import React, { useEffect, useState } from 'react';
import Activity from '../Activity/Activity';
import './Main.css';

const Main = () => {
    const [teachers, setTeachers] = useState([]);
    const [searches, setSearches] = useState([]);


    useEffect( () =>{
        fetch('data.json')
        .then(res => res.json())
        .then(data => setTeachers(data))
        },[]);

        const handleSearch = event =>{
            const searchText = event.target.value.toLowerCase();
            const match = teachers.filter(v => v.extra.toLowerCase().includes(searchText));
            setSearches(match);
        }
    return (
        <div>
            <div >
                <input className='input-class' onChange={handleSearch} type="text" placeholder='search here...' />
            </div>

            {
                searches.map(teacher => <Activity
                     key={teacher.id}
                     teacher ={teacher}
                
                ></Activity>)
            }
            
        </div>
    );
};

export default Main;